import angular from 'angular';

import SiteMgmt from './siteManagement.component';
import SiteModalMap from './siteModalMap.component';
import './siteManagement.component.scss';
import './siteManagement.modal.component.scss';

export default angular
  .module('petroCloud.admin.sites', [])
  .component(SiteModalMap.name, SiteModalMap)
  .component(SiteMgmt.name, SiteMgmt)
  .name;
